import * as React from 'react';
import type { SVGProps } from 'react';
import { memo } from 'react';
const TickIcon = (props: SVGProps<SVGSVGElement>) => (
    <svg xmlns="http://www.w3.org/2000/svg" width={22} height={19} viewBox="0 0 22 19" className="Icon tick" {...props}>
        <g fill="none" fillRule="evenodd">
            <path
                fill="#FFF"
                d="M9.414 16.828 8 18.243l-1.414-1.415-4.707-4.707-1.415-1.414L1.88 9.293l1.414-1.414 1.412-1.412 1.414 1.41 3.293 3.282-2.825.001 9.292-9.282L17.294.465l1.413 1.414 1.414 1.414 1.415 1.414-1.415 1.414z"
                className="tick-bg"
            />
            <path
                fill="#B5B5B5"
                d="M8 15.414 18.707 4.707l-1.414-1.414L8 12.575 4.707 9.293l-1.414 1.414z"
                className="tick-line"
            />
        </g>
    </svg>
);
const Memo = memo(TickIcon);
export default Memo;
